import SpotlightService from './SpotlightService';
import Logger from '../Logger';
import StateService from './StateService';
import ApplicationService from './ApplicationService';

const NavigationService = {
    showContent: function showContent (payload) {
        const content = this.getContent(payload);

        if (!content) {
            Logger.log('NavigationService', 'Content is either not available or not allowed')
            return null;
        }

        return StateService.advanceState(content);
    },

    getContent: function getContent (payload) {
        const validPayload = validate(payload);

        if (!validPayload) return null;

        return resolveContent(validPayload);
    }
};

function validate (payload) {
    if (!payload) return null;

    if (!payload.type) {
        Logger.error(['NavigationService'], 'command payload lacks type');
        return null;
    }

    if (!payload.id) {
        Logger.error(['NavigationService'], 'command payload lacks id');
        return null;
    }

    return payload;
}

function resolveContent ({ type, id }) {
    switch (type) {
        case 'Spotlight':
            const spotlight = getSpotlight(id);
            if (!spotlight) return null;

            return { type: 'spotlight', id, content: spotlight };
        case 'ApplicationInstance':
            const appInstance = getAppInstance(id);
            if (!appInstance) return null;

            return { type: 'application', id, content: appInstance };
        default:
            Logger.error(['NavigationService'], `unhandled content type: ${type} & id: ${id}`);
    }
}

function getSpotlight (id) {
    return SpotlightService.getSpotlight(id);
}

function getAppInstance (id) {
    return ApplicationService.getApplicationInstance(id);
}

export default NavigationService;